{
	"title": "Projecten",
	"table": {
		"reference": "Referentie",
		"quantity": "Totale hoeveelheid",
		"savings": "Totale CO\u2082-reducties",
		"fetchError": "Projecten konden niet worden opgehaald"
	},
	"showProjectsHistoryTitle": "Projectgeschiedenis tonen",
	"noProjects": {
		"createDeclaration": "Maak uw eerste verklaring aan",
		"description": "U kunt verklaringen aanmaken voor één of meerdere materialen door op “Verklaring aanmaken” te klikken."
	}
}
